import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables';

export const RegistrationStatusReport = async (payload) => {
    const result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `MHL_Reports/RegistrationStatusReport`, JSON.stringify(payload), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetRegistrationListBySearch = async (searchData) => {
    const result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `MHL_Reports/GetRegistrationListBySearch?searchData=${searchData}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UpdateTrfRequest = async (data) => {
    const result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `MHL_Reports/UpdateTrfRequest`, data, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const UpdateRniRequest = async (data) => {
    const result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `MHL_Reports/UpdateRniRequest`, data, CommonVariables.API_HEADER)).then(response => response);
    return result;
}